// Help Center block registry — the single place that maps a block type to its
// display metadata, blank config and shared renderer. Adding a new block = add
// one entry here + its Renderer + a Ruby sanitizer branch. The dashboard insert
// UI and the public portal island both read from this registry, so a block has
// exactly one implementation.

import AccordionBlock from './blocks/Accordion/AccordionBlock.vue';
import CarouselBlock from './blocks/Carousel/CarouselBlock.vue';
import GalleryBlock from './blocks/Gallery/GalleryBlock.vue';
import TableBlock from './blocks/Table/TableBlock.vue';
import ImageZoomBlock from './blocks/ImageZoom/ImageZoomBlock.vue';
import CardsBlock from './blocks/Cards/CardsBlock.vue';
import BannerBlock from './blocks/Banner/BannerBlock.vue';
import { HC_BLOCK_TYPES } from './blockConfig';

export const HC_BLOCKS = [
  {
    type: HC_BLOCK_TYPES.ACCORDION,
    nameKey: 'HELP_CENTER.BLOCKS.ACCORDION.NAME',
    icon: 'chevron-down',
    Renderer: AccordionBlock,
    defaultConfig: () => ({
      panels: [{ title: '', content: '', open: false, items: [] }],
    }),
  },
  {
    type: HC_BLOCK_TYPES.CAROUSEL,
    nameKey: 'HELP_CENTER.BLOCKS.CAROUSEL.NAME',
    icon: 'image',
    Renderer: CarouselBlock,
    defaultConfig: () => ({
      slides: [{ image: '', title: '', description: '', link: '' }],
      autoplay: false,
      interval: 5000,
      showIndicators: true,
      showNavigation: true,
    }),
  },
  {
    type: HC_BLOCK_TYPES.GALLERY,
    nameKey: 'HELP_CENTER.BLOCKS.GALLERY.NAME',
    icon: 'grid',
    Renderer: GalleryBlock,
    defaultConfig: () => ({
      images: [{ src: '', alt: '', caption: '' }],
      columns: 3,
      lightbox: true,
    }),
  },
  {
    type: HC_BLOCK_TYPES.TABLE,
    nameKey: 'HELP_CENTER.BLOCKS.TABLE.NAME',
    icon: 'table',
    Renderer: TableBlock,
    defaultConfig: () => ({
      headers: ['', ''],
      rows: [['', '']],
      align: 'left',
      // null = auto (paginate once rows exceed the threshold); true/false force it.
      pagination: null,
      pageSize: 10,
    }),
  },
  {
    type: HC_BLOCK_TYPES.IMAGE_ZOOM,
    nameKey: 'HELP_CENTER.BLOCKS.IMAGE_ZOOM.NAME',
    icon: 'zoom-in',
    Renderer: ImageZoomBlock,
    defaultConfig: () => ({ src: '', alt: '' }),
  },
  {
    type: HC_BLOCK_TYPES.CARDS,
    nameKey: 'HELP_CENTER.BLOCKS.CARDS.NAME',
    icon: 'card-ui',
    Renderer: CardsBlock,
    defaultConfig: () => ({
      items: [
        {
          image: '',
          icon: '',
          title: '',
          subtitle: '',
          description: '',
          link: '',
          newTab: false,
        },
      ],
      columns: 3,
    }),
  },
  {
    type: HC_BLOCK_TYPES.BANNER,
    nameKey: 'HELP_CENTER.BLOCKS.BANNER.NAME',
    icon: 'panel-position-bottom',
    Renderer: BannerBlock,
    defaultConfig: () => ({ tag: '', title: '', subtitle: '', image: '' }),
  },
  {
    // Grid shares the Cards renderer and item shape — it's only a denser
    // default column count, mirroring the legacy ERB partials (see
    // _dynamic_grid.html.erb, which rendered _dynamic_cards.html.erb).
    type: HC_BLOCK_TYPES.GRID,
    nameKey: 'HELP_CENTER.BLOCKS.GRID.NAME',
    icon: 'grid-dots',
    Renderer: CardsBlock,
    defaultConfig: () => ({
      items: [
        {
          image: '',
          icon: '',
          title: '',
          subtitle: '',
          description: '',
          link: '',
          newTab: false,
        },
      ],
      columns: 4,
    }),
  },
];

export const HC_BLOCK_MAP = HC_BLOCKS.reduce((map, block) => {
  map[block.type] = block;
  return map;
}, {});

export function getHcBlock(type) {
  return HC_BLOCK_MAP[type] || null;
}
